<template>
  <div>
    <HeaderMenu :img_header="header_image" header="เมนูขาย"/>
    <div class="grid_item justify-space-between mb-5">
      <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
        <router-link class="menu_team_link" to="/sell/sellreport">
          <div class="menu_team_img">
            <img src="@/assets/clipboard_report.png">
          </div>
          <div>
            รายงานการขาย
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
        <router-link class="menu_team_link" to="/sell/orderretailcustomers">
          <div class="menu_team_img">
            <img src="@/assets/order_all.png">
          </div>
          <div>
            เมนูคำสั่งซื้อ <v-badge  v-if="newOrderCount_menu !== null"   v-show="newOrderCount_menu > 0" color="red" :content="newOrderCount_menu" inline class=" blinking"/>
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team flex-grow-1 text-center ml-1 mr-1">
        <router-link class="menu_team_link" to="/refund/refundwaitforprocess">
          <div class="menu_team_img">
            <img src="@/assets/return_refund.png">
          </div>
          <div>
            รับคืนสินค้า
          </div>
        </router-link>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import HeaderMenu from "@/components/admin/sell/header_sell/HeaderMenu";
import HeaderImage from "@/assets/clipboard_2.png";
export default {
  name: "SellMenuAll",
  components: {
    HeaderMenu
  },
  data() {
    return {
      header_image: HeaderImage,
      newOrderCount_menu: null, // ให้รู้ว่ายังไม่โหลด
    }
  },
  methods: {
    async fetchNewOrderCountMenu() {
      try {
        const res = await HTTP.get('/wholesales/orders/count-new')
        this.newOrderCount_menu = res.data.count
      } catch (error) {
        console.error('Fetch order count failed', error)
      }
    }
  },
  mounted() {
    this.fetchNewOrderCountMenu()
  },
}
</script>

<style scoped>
.blinking {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}

.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
.grid_flex {
  display: flex;
}
.grid_item {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 500px) {
  .grid_item {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
